import { BehaviorSubject, Subject } from 'rxjs';
import { CoordinatorService } from './coordinator.service';
import { Search } from './search';
// import { SearchField } from './search-field';
import { tableTagLs } from './filter-specials';
// import { Autotag } from './autotag';
import { BinaryTree } from './binary-tree';
import { Stage } from './stage';
import { SEARCH_HELP, SEARCH_ITEM_HELP_DATA } from './search-archive$';

export class Search$ {
    activeFieldChange$ = new Subject<void>();

    current$ = new BehaviorSubject<Search | undefined>(undefined);
    // private _searchFieldMap?: Map<string, SearchField>;

    // activeSet = new Set<string>()

    // previewSearchLs: Autotag[] = [];
    // mainSearchLs: Autotag[] = [];

    highlightStyle = `
    background-color: #FFFF99; 
    border: 1px solid #FFCC66; 
    padding: 2px 4px; 
    border-radius: 3px; 
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
    font-weight: bold;
    color: #333;
    `;

    constructor(public coords: CoordinatorService) {}

    onStart() {
        this.current$.next(new Search(this.coords));
        // this._searchFieldMap = new Map(
        //     tableTagLs
        //         // .filter(x => x != "view")
        //         .map((x) => new SearchField(this.coords, x))
        //         .map((x) => [x.tag, x]),
        // );

        // const cutoffF = new SearchField(this.coords, 'cutoff');
        // this._searchFieldMap.set(cutoffF.tag, cutoffF);

        // const viewF = new SearchField(this.coords, 'view');
        // this._searchFieldMap.set(viewF.tag, viewF);
        // const hitsetF = new SearchField(this.coords, 'hitset');
        // this._searchFieldMap.set(hitsetF.tag, hitsetF);
    }

    initNewProject() {
        console.log('INIT NEW PROJECT', this.coords.pin$.misc);
        this.coords.pin$.misc?.on('show-field-text');
        // ['text', 'year', 'source'].forEach(x =>
        // ['text'].forEach((x) => (this._searchFieldMap!.get(x)!.isOn = true));
    }

    clearSection(tag: string) {
        switch (tag) {
            case 'selections':
                this.coords.selection$.clearButtonAction();
                break;
            case 'search':
                this.coords.field$.clearButtonAction();
                // this.coords.search$.refresh();
                break;
            case 'filters':
                this.coords.filter$.clearButtonAction();
            // this.coords.anyMessage$.next({ action: `clear-${tag}` });
        }
    }

    clearAll() {
        this.clearSection('selections');
        this.clearSection('search');
        this.clearSection('filters');
        // this.coords.resultList$.resetSelection();
    }

    save() {
        const ls: string[] = [];

        ls.push(`const searchInterface = interface("search")`);
        ls.push(`searchInterface.reset()`);
        this.coords.field$.save(ls);
        this.coords.filter$.save(ls);
        this.coords.selection$.save(ls);
        return ls.join(';\n');
    }

    saveRun() {
        const ls: string[] = [];
        ls.push(`const hitsetLs = []`);

        this.coords.field$.saveRun(ls);
        this.coords.filter$.saveRun(ls);
        this.coords.selection$.saveRun(ls);

        // ls.push("console.log(hitsetLs)");
        ls.push('return hitsetLs');
        return ls.join(';\n');
    }

    saveHelp() {
        const resp: SEARCH_HELP = { fieldLs: [], filterLs: [], selectionLs: [] };
        this.coords.field$.saveHelp(resp);
        this.coords.filter$.saveHelp(resp);
        this.coords.selection$.saveHelp(resp);
        console.log('saveHelp', resp);
        return resp;
    }
}
